import { render, staticRenderFns } from "./entrusted-case.vue?vue&type=template&id=d21e99e6&scoped=true"
import script from "./entrusted-case.vue?vue&type=script&lang=ts"
export * from "./entrusted-case.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21e99e6",
  null
  
)

export default component.exports